module.exports = __webpack_public_path__ + "img/127047329117.4611edd0.png";